import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { WeddingApp } from "./components/wedding/WeddingApp";
import { HomePage } from "./components/HomePage";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main Wedding Invitation Route */}
        <Route path="/nauval-rifa-wedding" element={<WeddingApp />} />

        {/* Root Route - Simple Home Page */}
        <Route path="/" element={<HomePage />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
